/**
 *  Error related to parsing GID
 */
export class ParseGidError extends Error {
  name = 'ParseGidError';
}
